import fetchInterceptor, { FetchOptions } from "../../../utils/fetchInterceptor ";
import { getNewReqClientEndpoint as endpoint } from "../apiEndpoint";
import { header } from "../../../context/constant";
const GetNewRequestedClientAPI = async () => {
    const url = endpoint()
    const options: FetchOptions = {
        method: "GET",
        headers: header,
    }
    return fetchInterceptor(url, options)
};
export default GetNewRequestedClientAPI;